<template>
    <!-- 项目统计 -->
    <div>
        <!-- 头部-->
        <div class="city-child-head">
            <!-- 标题 -->
            <div class="city-child-head-left float-l">
                <div class="city-child-head-icon"></div>
                <span>项目统计</span>
            </div>
        </div>
        <!-- 内容 -->
        <div class="city-content city-content-chunk-box">
            <!-- 总计 -->
            <div class="city-box">
                <div class="city-box-1" v-for="(item, index) in totalPage" :key="index">
                    <svg-icon :icon-file-name="item.icon" class="round-icon" />
                    <div>
                        <div class="t-title">{{ item.title }}</div>
                        <div class="text-1">
                            <span class="text-1-num">
                                {{ item.data || 0 }}
                            </span>
                            <span class="t-title">{{ item.unit }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="city-box-board">
                <dv-scroll-board class="dv-scr-board" :config="config" />
            </div>
        </div>
    </div>
</template>
<script>
import { subitemStatisticsNow, subitemTopFiveNow } from '../../api/holdMy.js';

export default {
    data() {
        return {
            refreshImgIng: null,   // 刷新定时器
            tabIndex: 0,
            tableData: [],
            loadingAvgWaitCarCount: 0,
            loadingAvgWaitTime: 0,
            todaytotalTransportOrderCount: 0,
            totalPage: [
                { title: '项目平均等待车辆数', unit: '辆', icon: 'u208', data: '' },
                { title: '项目平均等待时间', unit: '分', icon: 'u207', data: '' },
                { title: '今日运单数', unit: '笔', icon: 'u209', data: '' },
            ],
            getData: {
                cityName: this.$route.query.cityName,
                city: this.$route.query.cityName,
            },
            config: {
                header: ['项目', '平均等待时间', '平均等待车辆', '今日运单数'],
                data: [],
                rowNum: 20, //表格行数
                headerHeight: 27,
                headerBGC: 'rgba(0,144,255,0.2)', //表头
                oddRowBGC: 'rgba(26, 201, 255, 0)', //奇数行
                evenRowBGC: 'rgba(26, 201, 255, 0', //偶数行
                align: ['left', 'left', 'center', 'center'],
                columnWidth: [65, 65, 60, 60],
            }
        }
    },
    components: {},
    created() {

    },
    mounted() {
        this.refreshScale();
    },

    beforeDestroy() {
        clearInterval(this.refreshImgIng);
    },
    methods: {
        // 刷新数据
        refreshScale() {
            this.getSubitemStatisticsNow();
            this.getSubitemTopFiveNow();
            this.refreshImgIng = setInterval(() => {
                this.getSubitemStatisticsNow();
                this.getSubitemTopFiveNow();
            }, 1000 * 60 * 30)
        },

        // 获取项目统计
        getSubitemStatisticsNow() {
            subitemStatisticsNow({ ...this.getData }).then(res => {
                if (res.result == 0) {
                    this.totalPage[0].data = res.userdata.loadingAvgWaitCarCount ? res.userdata.loadingAvgWaitCarCount : 0;
                    this.totalPage[1].data = res.userdata.loadingAvgWaitTime ? res.userdata.loadingAvgWaitTime : 0;
                    this.totalPage[2].data = res.userdata.todaytotalTransportOrderCount ? res.userdata.todaytotalTransportOrderCount : 0;
                    // 当数据变化时触发更新
                    this.$store.dispatch('updateOrderCount', this.totalPage[2].data);
                }
            }).catch(error => {
                console.log(error);
            })
        },

        // 获取系统信息列表
        getSubitemTopFiveNow() {
            let that = this;
            subitemTopFiveNow({ ...this.getData }).then(res => {
                if (res.result == 0) {
                    let userdata = res.userdata;
                    let data = [];
                    userdata.forEach(e => {
                        data.push([
                            `<span style="color:rgba(255, 255, 255, 0.4980392156862745);">${e.name ? e.name : ""}</span>`,
                            e.loadingAvgWaitTime ? e.loadingAvgWaitTime : 0,
                            e.loadingAvgWaitCarCount ? e.loadingAvgWaitCarCount : 0,
                            e.todayTotalTransportOrderCount ? e.todayTotalTransportOrderCount : 0])
                    })
                    that.config.data = data;
                    that.config = { ...that.config }; //关键,展开数组对象重新赋值.不写数据出不来
                }
            }).catch(error => {
                console.log(error);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/city.scss';

.city-content {
    height: 100%;

    .city-box {
        height: 240px;
        padding: 16px 0px;

        &-board {
            height: calc(100% - 240px);
        }

        .city-box-1 {
            display: flex;
            align-items: center;
            margin: 8px 0px 0px 12px;

            .round-icon {
                width: 73px;
                height: 62px;
                margin-right: 4px;
            }

            .text-1 {
                font-size: 20px;
                color: #FFFFFF;

                &-num {
                    font-size: 24px;
                    margin-right: 4px;
                    line-height: 35px;
                }
            }
        }
    }
}

@keyframes blinker {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

.dv-scr-board {
    width: 100%;
    height: 100%;
}

::v-deep .dv-scr-board .rows {
    height: 100% !important;
}
</style>
